module.exports = __webpack_public_path__ + "static/media/2.f7688fa2.png";